import React from "react";

export default function TitleBlock({
  data = {},
  paper,
  pxPerMm = 3,
  marginMm = 10,
  widthMm = 170,
  heightMm = 45,
}) {
  const paperWidthMm = Number(paper?.widthMm || 420);
  const paperHeightMm = Number(paper?.heightMm || 297);

  const xMm = paperWidthMm - marginMm - widthMm;
  const yMm = paperHeightMm - marginMm - heightMm;

  const borderWidth = Math.max(1, 0.18 * pxPerMm);
  const labelFont = 1.9 * pxPerMm;
  const valueFont = 2.45 * pxPerMm;
  const padX = 1.5 * pxPerMm;
  const padY = 0.9 * pxPerMm;

  const cellStyle = {
    padding: `${padY}px ${padX}px`,
    overflow: "hidden",
  };

  const labelStyle = {
    fontSize: labelFont,
    textTransform: "uppercase",
    letterSpacing: 0.04 * pxPerMm,
    color: "#64748b",
    lineHeight: 1,
    marginBottom: 0.45 * pxPerMm,
    whiteSpace: "nowrap",
  };

  const valueStyle = {
    fontSize: valueFont,
    fontWeight: 700,
    color: "#0f172a",
    lineHeight: 1.1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const rowBorderStyle = {
    borderBottom: `${borderWidth}px solid #0f172a`,
  };

  const colBorderStyle = {
    borderRight: `${borderWidth}px solid #0f172a`,
  };

  return (
    <div
      style={{
        position: "absolute",
        left: xMm * pxPerMm,
        top: yMm * pxPerMm,
        width: widthMm * pxPerMm,
        height: heightMm * pxPerMm,
        zIndex: 20,
        background: "white",
        border: `${borderWidth}px solid #0f172a`,
        color: "#0f172a",
        pointerEvents: "none",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "36%",
          ...rowBorderStyle,
        }}
      >
        <div
          style={{
            flex: 1,
            ...cellStyle,
            ...colBorderStyle,
          }}
        >
          <div style={labelStyle}>Project</div>
          <div style={valueStyle}>
            {data.projectName || "Interior Project"}
          </div>
        </div>

        <div
          style={{
            width: "38%",
            ...cellStyle,
          }}
        >
          <div style={labelStyle}>Drawing No.</div>
          <div style={valueStyle}>
            {data.drawingNumber || "A-001"}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          height: "27%",
          ...rowBorderStyle,
        }}
      >
        <div
          style={{
            flex: 1,
            ...cellStyle,
            ...colBorderStyle,
          }}
        >
          <div style={labelStyle}>Drawing Title</div>
          <div style={valueStyle}>
            {data.title || "Interior Documentation"}
          </div>
        </div>

        <div
          style={{
            width: "38%",
            ...cellStyle,
          }}
        >
          <div style={labelStyle}>Scale</div>
          <div style={valueStyle}>
            {data.scale || "As indicated"}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          height: "37%",
        }}
      >
        <div
          style={{
            width: "35%",
            ...cellStyle,
            ...colBorderStyle,
          }}
        >
          <div style={labelStyle}>Date</div>
          <div style={valueStyle}>
            {data.date || ""}
          </div>
        </div>

        <div
          style={{
            width: "22%",
            ...cellStyle,
            ...colBorderStyle,
          }}
        >
          <div style={labelStyle}>Rev</div>
          <div style={valueStyle}>
            {data.revision || "P01"}
          </div>
        </div>

        <div
          style={{
            flex: 1,
            ...cellStyle,
          }}
        >
          <div style={labelStyle}>System</div>
          <div style={valueStyle}>Modular Objects</div>
        </div>
      </div>
    </div>
  );
}